export const palette = {
  // Brand colors
  BROWN: '#303232', // changed to gray
  YELLOW: '#FDDE66',
  BEIGE: '#f2f2f2',
  ORANGE: '#FF9003',
  GREEN: '#4A7222',
  OLIVE: '#625845',
  // ORANGE: '#FBAD2B',

  // UI colors
  ALERTRED: '#F30101',
  ALERTORANGE: '#F39700',
  ALERTGREEN: '#5cb85c',
  LINKCOLOR: '#C84900',
  BLUE: '#3571f7',
  // LINKCOLOR: '#be6e04',

  // Shades of Gray
  GRAYDARKER: '#222222',
  GRAYDARK: '#333333',
  GRAY: '#555555',
  GRAYLIGHTISH: '#656565',
  GRAYLIGHT: '#777777',
  GRAYLIGHTERSHADOW: '#B9B9B9',
  GRAYLIGHTER: '#EEEEEE',
  GRAYLIGHTEST: '#f2f2f2',
  GRAYLIGHTESTEST: '#f9f9f9',

  ALIZARIN: '#f16657',
  AMETHYST: '#8a2754',
  SUNFLOWER: '#f7ce31',
  COCONUTCREAM: '#F7EFD3',

  // Semantic Colors
  ERROR: {
    '100': '#fdf5f4',
    '200': '#f7d5d2',
    '300': '#e1574d',
    '400': '#d92d20',
    '500': '#57120d',
  },
  INFO: {
    100: '#f5f8ff',
    200: '#d7e3fd',
    300: '#6091f8',
    400: '#3875f6',
    500: '#162f62',
  },
  SUCCESS: {
    100: '#f3faf7',
    200: '#cdeadd',
    300: '#35ad77',
    400: '#039855',
    500: '#013d22',
  },
  WARNING: {
    100: '#faf0cb',
    200: '#e1d8b7',
    300: '#e99945',
    400: '#e38016',
    500: '#5b3309',
  },
}

export const AVATAR_COLORS = [
  palette.GRAYLIGHT,
  palette.ALIZARIN,
  palette.ORANGE,
  palette.AMETHYST,
  palette.GRAY,
  palette.SUNFLOWER,
  palette.GRAYDARKER,
]

export const DATA_VIZ_PALETTE = {
  green: '#8de0ad',
  blue: '#65adf0',
  purple: '#4F62B7',
}

export const CLEARFIX = {
  content: '" "',
  visibility: 'hidden',
  display: 'block',
  height: 0,
  clear: 'both',
}

export const SCREENSIZE = {
  XS: 480,
  SM: 768,
  MD: 992,
  LG: 1200,
}

export const ANIMATION = 'all .20s ease'

export const UISIZE = {
  sidebarWidth: 60,
  header: 46,
  reportHeader: 48,
  sectionHeaderHeight: 44,
  // job screen
  headerOffset: 48,
  scrollSpyOffset: 25,
  secondaryJobformNavWidth: 220,
  secondaryReportNavWidth: 220,
  xsJobHeader: 92, // size of stacked job header on small screen
  dynamicAlertWidth: 500,
}
